const NEXT_VISIT_FILTER = Object.freeze({
  ANY_DATE: 'anyDate',
  NEXT_7_DAYS: 'next7days',
  NO_FUTURE: 'noFuture',
});

export default NEXT_VISIT_FILTER;
